/*
 * Copyright (c) 2025. Bolmate B.V.
 */
import './style/confirmationMessage.scss';

import React, {MouseEventHandler, PropsWithChildren} from 'react';
import classNames from 'classnames';
import {AwesomeIcon} from '@dvrd/dvr-controls';

interface Props {
    onClose?: MouseEventHandler;
    className?: string;
    closeText?: string;
}

export default function ConfirmationMessage(props: PropsWithChildren<Props>) {
    const {className, children, onClose} = props;
    const closeText = props.closeText ?? 'Oké, ik begrijp het';
    const gridColumns = onClose === undefined ? 'fit-content(100%) 1fr' : 'fit-content(100%) 1fr fit-content(100%)';
    return (
        <div className={classNames('confirmation-message-container', className)}
             style={{gridTemplateColumns: gridColumns}}>
            <AwesomeIcon name='thumbs-up' className='thumbs'/>
            {children}
            {onClose !== undefined && <label className='close-label' onClick={onClose}>{closeText}</label>}
        </div>
    )
}